// frontend/js/classIndex.js
// Class index page - displays all available pedagogical sessions

// Helper function to get translation
function t(key, fallback) {
  if (window.i18n && typeof window.i18n.t === 'function') {
    const result = window.i18n.t(key);
    return result !== key ? result : fallback;
  }
  return fallback;
}

// Get current language
function getCurrentLang() {
  if (window.i18n && window.i18n.lang) {
    return window.i18n.lang;
  }
  return 'en';
}

async function loadClasses() {
  const container = document.getElementById('class-list');
  const lang = getCurrentLang();

  try {
    const res = await fetch(`/api/classes?lang=${lang}`);

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const classes = await res.json();

    if (!classes || classes.length === 0) {
      container.innerHTML = `<p style="opacity: 0.7;">${t('classes.no_classes', 'No classes available yet.')}</p>`;
      return;
    }

    renderClasses(classes, container);
  } catch (err) {
    console.error('Error loading classes:', err);
    container.innerHTML = `<p style="opacity: 0.7;">${t('classes.load_error', 'Unable to load classes. Please try again later.')}</p>`;
  }
}

function renderClasses(classes, container) {
  container.innerHTML = '';

  classes.forEach(cls => {
    const card = document.createElement('div');
    card.className = 'class-card';
    card.onclick = () => {
      window.location.href = `/classview?id=${cls.id}`;
    };

    const levelLabel = t('classes.level', 'Level');
    const durationLabel = t('classes.duration', 'Duration');
    const minLabel = t('classes.minutes', 'min');

    card.innerHTML = `
      <div class="class-title">${escapeHtml(cls.title)}</div>
      <div class="class-tagline">${escapeHtml(cls.tagline || '')}</div>
      <div class="class-meta">
        ${levelLabel}: ${escapeHtml(cls.level || t('classes.mixed_level', 'mixed'))}<br>
        ${durationLabel}: ${cls.durationMinutes || 60} ${minLabel}
      </div>
    `;

    container.appendChild(card);
  });
}

// Simple HTML escape function to prevent XSS
function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

// Wait for i18n to be ready, then load classes
function init() {
  if (window.i18n) {
    loadClasses();
    // Re-render on language change
    document.addEventListener(window.i18n.EVENT_NAME || 'languagechange', loadClasses);
  } else {
    // Fallback: load without translations
    loadClasses();
  }
}

// Load classes when page loads
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
